<template>
  <div>
    <input-field label="数据点名称" v-model="iName" :disabled="!editable"></input-field>
    <input-field label="数据点ID" v-model="iId" :disabled="!editable"></input-field>
    <input-field label="数据点单位" v-model="iUnit" :disabled="!editable"></input-field>
    <select-field label='关联采集设备' v-model="device" :list="devices" :disabled="!editable"></select-field>
    <select-field label='关联采集数据' v-model="data" :list="datas" :disabled="!editable"></select-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  /**
   * defaults example: {
   *   deviceId: 1,
   *   dataId: 1,
   *   iName: 'point 1',
   *   iId: 'point #1',
   *   iUnit: 'm',
   *   devices: [
   *     {
   *       name: '设备1',
   *       id: 1,
   *       datas: [
   *         {
   *           name: '数据点1',
   *           id: 1
   *         }
   *       ]
   *     }
   *   ]
   * }
   */
  import SelectField from '@/components/utils/select-field'
  import InputField from '@/components/utils/input-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    data () {
      return {
        iName: '',
        iId: '',
        iUnit: '',
        deviceType: '',
        device: {},
        data: {}
      }
    },
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'interface',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    components: {
      SelectField,
      InputField,
      SubmitField
    },
    methods: {
      refresh () {
        let deviceId = this.defaults.deviceId
        let dataId = this.defaults.dataId

        this.setValue(deviceId, dataId)
      },
      setValue (deviceId, dataId) {
        this.iName = this.defaults.iName
        this.iId = this.defaults.iId
        this.iUnit = this.defaults.iUnit

        this.device = ''
        this.data = ''

        this.defaults.devices.forEach(device => {
          if (deviceId === device.id) {
            this.device = device

            device.datas.forEach(data => {
              if (dataId === data.id) {
                this.data = data
              }
            })
          }
        })
      },
      submit () {
        this.$emitter.emit(this.event, {
          _id: this.defaults._id,
          iName: this.iName,
          iId: this.iId,
          iUnit: this.iUnit,
          deviceId: this.device.id,
          dataId: this.data.id
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    },
    created () {
      this.refresh()
    },
    computed: {
      devices () {
        return this.defaults.devices.map(device => {
          return {
            key: device.name,
            value: device
          }
        })
      },
      datas () {
        return (this.device && this.device.datas) ? this.device.datas.map(data => {
          return {
            key: data.name,
            value: data
          }
        }) : []
      },
      isValid () {
        return this.iName && this.iId && this.iUnit && this.device && this.data
      }
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/upload-data.vue